<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-itemdetails");

    export let type;

    export function open() {
        //manage focus
        jQuery('#GPItemDetailsModal').on('show.bs.modal',GP.storeFocus);
        jQuery('#GPItemDetailsModal').on('shown.bs.modal',function (){jQuery('#GPItemDetailsModal .close').focus();});
        jQuery('#GPItemDetailsModal').on('hidden.bs.modal',GP.restoreFocus);

        //trap focus
        jQuery('#GPItemDetailsModal .close').on('keydown', function(e) {if (e.which===9) e.preventDefault();});

        jQuery('#GPItemDetailsModal').modal({});
        jQuery('#GPItemDetailsModal').on('hidden.bs.modal', () => this.$destroy());
    }


</script>

<div class="modal fade GPModal type-{type.typeName}" tabindex='-1' id="GPItemDetailsModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{type.name}</h4>
            </div>
            <div class="modal-body">
                <slot></slot>
            </div>
            <div class="modal-footer">
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
